import React from 'react';
import styled from 'styled-components';
import { colorTokens } from '../../../../../tokens/globals/tokens';
import { sitekitTokens } from '../../../../../tokens/components/SiteKit/tokens';
import { useSiteKit } from '../../SiteKitContext/SiteKitContext';

// Subcomponents
import { SiteKitControls } from '../SiteKitControls/SiteKitControls';
import { SiteKitHeadlines } from '../SiteKitHeadlines/SiteKitHeadlines';
import { SiteKitUtilities } from '../SiteKitUtilities/SiteKitUtilities';
import { SiteKitWorkspaceSelector } from '../SiteKitWorkspaceSelector';

// Fragments
const SiteKitSidebarWrapper = styled.nav`
  background: ${sitekitTokens.CoreSidebarBackgroundColor};
  border-block-end: 1px solid ${colorTokens.GlobalBrandGray30};
  color: ${colorTokens.GlobalBrandBlack};
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: space-between;
`;

// Exports
interface SiteKitSidebarProps {
  children: React.ReactNode;
}
const SiteKitSidebar = ({ children }: SiteKitSidebarProps) => {
  const { sidebarOpen } = useSiteKit();
  return sidebarOpen ? <SiteKitSidebarWrapper>{children}</SiteKitSidebarWrapper> : null;
};
SiteKitSidebar.Controls = SiteKitControls;
SiteKitSidebar.Headlines = SiteKitHeadlines;
SiteKitSidebar.Utilities = SiteKitUtilities;
SiteKitSidebar.WorkspaceSelector = SiteKitWorkspaceSelector;

SiteKitSidebar.displayName = 'SiteKit.Sidebar';

export { SiteKitSidebar, SiteKitSidebarProps };
